import { MdAdd, MdInfoOutline } from 'react-icons/md';
import { RiDoorLockLine } from 'react-icons/ri';
import ArchiveIcon from './components/others/icons/ArchiveIcon';
import BookingsIcon from './components/others/icons/BookingsIcon';
import CalendarIcon from './components/others/icons/CalendarIcon';
import ContractsIcon from './components/others/icons/ContractsIcon';
import CustomersIcon from './components/others/icons/CustomersIcon';
import DashboardIcon from './components/others/icons/DashboardIcon';
import DatePickerIcon from './components/others/icons/DatePickerIcon';
import DatesRangeIcon from './components/others/icons/DatesRangeIcon';
import DeleteIcon from './components/others/icons/DeleteIcon';
import DownloadIcon from './components/others/icons/DownloadIcon';
import EditIcon from './components/others/icons/EditIcon';
import GuestsIcon from './components/others/icons/GuestsIcon';
import ImagesIcon from './components/others/icons/ImagesIcon';
import MapIcon from './components/others/icons/MapIcon';
import NoteIcon from './components/others/icons/NoteIcon';
import PropertiesIcon from './components/others/icons/PropertiesIcon';
import PublishIcon from './components/others/icons/PublishIcon';
import SingleUserIcon from './components/others/icons/SingleUserIcon';
import UnarchiveIcon from './components/others/icons/UnarchiveIcon';
import UnpublishIcon from './components/others/icons/UnpublishIcon';
import UsersIcon from './components/others/icons/UsersIcon';
import WorkplacesIcon from './components/others/icons/WorkplacesIcon';

const icons = {
  dashboard: DashboardIcon,
  properties: PropertiesIcon,
  bookings: BookingsIcon,
  guests: GuestsIcon,
  users: UsersIcon,
  singleUser: SingleUserIcon,
  customers: CustomersIcon,
  notes: NoteIcon,
  contracts: ContractsIcon,
  rooms: RiDoorLockLine,
  workplaces: WorkplacesIcon,
  details: MdInfoOutline,
  edit: EditIcon,
  delete: DeleteIcon,
  add: MdAdd,
  map: MapIcon,
  archive: ArchiveIcon,
  unarchive: UnarchiveIcon,
  datesRange: DatesRangeIcon,
  calendar: CalendarIcon,
  datePicker: DatePickerIcon,
  download: DownloadIcon,
  images: ImagesIcon,
  publish: PublishIcon,
  unpublish: UnpublishIcon,
};

export default icons;
